import styles from "./../StudentPage.module.css";

export default function StartScreen({ onStart }) {
    return (
        <div className={styles.content__button}>
            <p className={styles.button__text}>Are you ready?</p>
            <button onClick={onStart}>Yes</button>
            <p className={styles.button__description}>
                If you would like to publish your article or commission a new one,
                please follow the link.
            </p>
        </div>
    );
}
